import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_COUNTRIES } from "../../config/connString";
import useAxios from "../../utils/useAxios";
const updateCountry = createAsyncThunk(
  "countries/update-countries",
  async (data) => {
    try {
      const api = useAxios();

      const response = await api.put(URL_COUNTRIES + "/" + data[0], {
        id: data[0],
        name: data[1].name,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { updateCountry };
